module.exports = "<div ng-if=\"$ctrl.options\" \n     class=\"gridProductBarcodesStyle\" \n     ui-grid-cellNav\n     ui-grid-selection\n     ui-grid-edit \n     ui-grid-row-edit\n     ui-grid=\"$ctrl.options\"></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/product-barcodes/product-barcodes.html
// module id = 74
// module chunks = 0